exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#btnSubmitAvg {\n\tmargin-top: 33px;\n}\n.wrapper-chart {\n    width: 90%;\n    margin-top: 50px;\n}\n", ""]);

// exports
